import moment from "moment";
import React from "react";

type Stop = {
    distance: number;
    duration: number;
};

interface Props {
    stops: Stop[];
}

const formatTime = (duration: number): string => {
    if (!duration) return "0min";
    const durationM = moment.duration(duration, "seconds");
    const hour = durationM.hours();
    const min = durationM.minutes();

    if (hour > 0) {
        return `${hour}h${String(min).padStart(2, "0")}min`;
    } else {
        return `${String(min).padStart(2, "0")}min`;
    }
};

const Route = ({ stops }: Props) => {
    // Protege para stops ser sempre array
    const totalDuration = Array.isArray(stops) ? stops.reduce((acc, step) => acc + step.duration, 0) : 0;

    // Função para calcular a posição do pin com base no tempo acumulado
    const calculatePosition = (accumulatedDuration: number, totalDuration: number) => {
        return (accumulatedDuration / totalDuration) * 100;
    };

    const Icons = ({ steps }: { steps: Stop[] }) => {
        let accumulatedDuration = 0; // Resetando o acumulado para cada parte

        return (
            <div className="display-flex position-relative width-100pct padding-y-2 align-items-end">
                <div
                    className="position-absolute display-flex flex-column align-items-center"
                    style={{
                        left: `0%`,
                        transform: "translateX(-50%)",
                    }}
                >
                    <span className="rioglyph rioglyph-start text-color-dark text-size-14" />
                </div>

                {/* Protege para steps ser sempre array */}
                {(Array.isArray(steps) ? steps : []).map((step, index) => {
                    // Atualizando a duração acumulada
                    accumulatedDuration += step.duration;

                    // Calculando a posição do pin com base no tempo acumulado
                    const position = calculatePosition(accumulatedDuration, totalDuration);

                    return (
                        <div
                            key={index}
                            className="position-absolute display-flex flex-column align-items-center"
                            style={{
                                left: `${position}%`, // Posição com base no tempo acumulado
                                transform: "translateX(-50%)",
                            }}
                        >
                            <span className="margin-bottom-1 text-color-dark text-size-14 text-normal">
                                {formatTime(step.duration)}
                            </span>
                            <span
                                className={`rioglyph ${index === steps.length - 1 ? "rioglyph-finish" : "rioglyph-pushpin"
                                    } text-color-dark text-size-14`}
                            />
                        </div>
                    );
                })}
            </div>
        );
    };

    const TimelineBar = ({ steps }: { steps: Stop[] }) => {
        let accumulatedDuration = 0; // Resetando o acumulado para cada parte

        return (
            <div className="position-relative bg-highlight-light width-100pct height-10">
                <div
                    className="position-absolute top-0 bottom-0 bg-dark width-2"
                    style={{
                        left: `0%`,
                        transform: "translateX(-50%)",
                    }}
                />

                {/* Protege para steps ser sempre array */}
                {(Array.isArray(steps) ? steps : []).map((step, index) => {
                    // Atualizando a duração acumulada
                    accumulatedDuration += step.duration;

                    // Calculando a posição do pin com base no tempo acumulado
                    const position = calculatePosition(accumulatedDuration, totalDuration);

                    return (
                        <div
                            key={index}
                            className="position-absolute top-0 bottom-0 bg-dark width-2"
                            style={{
                                left: `${position}%`, // Posição com base no tempo acumulado
                                transform: "translateX(-50%)",
                            }}
                        />
                    );
                })}

                <div
                    className="position-absolute top-0 bottom-0 bg-dark width-2"
                    style={{
                        left: `100%`,
                        transform: "translateX(-50%)",
                    }}
                />
            </div>
        );
    };

    return (
        <div className="width-100pct padding-top-20">
            <Icons steps={stops} />
            <TimelineBar steps={stops} />
        </div>
    );
};

export default Route;
